export default __webpack_public_path__ + "static/047-cefcc95971424718e1762ce09f12f98a.png";